export enum TennisPerformanceCategory {
	MatchFormat = 'tennis_match_format',
	ServePerformance = 'tennis_serve_performance',
	ErrorsShotMaking = 'tennis_errors_shot_making',
	SetLevelOutcomes = 'tennis_set_level_outcomes',
}

export const TENNIS_PERFORMANCE_CATEGORY_LABELS: Record<TennisPerformanceCategory, string> = {
	[TennisPerformanceCategory.MatchFormat]: 'Match Format',
	[TennisPerformanceCategory.ServePerformance]: 'Serve Performance',
	[TennisPerformanceCategory.ErrorsShotMaking]: 'Errors & Shot-Making',
	[TennisPerformanceCategory.SetLevelOutcomes]: 'Set-Level Outcomes',
};
